import { Options, Vue } from 'vue-class-component';
import { walletRefundsService } from '@services/wallet-refunds.service';
import { WalletRefund, WalletRefundStatus } from '@/model/WalletRefund';
import { Entity } from '@/model/Entity';

import { DateFormatted } from '@sharedComponents';
import { PageHeader } from '@/components';

@Options({
  components: {
    PageHeader,
    DateFormatted,
  },
})
export default class WalletRefundDetail extends Vue {
  refund: WalletRefund | null = null;
  loading = false;

  get refundId(): number {
    return parseInt(this.$route.params.id as string);
  }

  async created() {
    await this.loadRefund();
  }

  async loadRefund() {
    try {
      this.loading = true;
      this.refund = await walletRefundsService.getById(this.refundId);
    } catch (error) {
      console.error('Error loading wallet refund:', error);
      this.$toast.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Impossibile caricare il rimborso',
        life: 3000,
      });
    } finally {
      this.loading = false;
    }
  }

  formatAmount(amount: any): string {
    if (!amount) return '€ 0,00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(numAmount)) return '€ 0,00';
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(numAmount);
  }

  getStatusLabel(status?: WalletRefundStatus): string {
    if (!status) return '';
    switch (status) {
      case WalletRefundStatus.REQUESTED:
        return 'Richiesto';
      case WalletRefundStatus.REFUNDED:
        return 'Rimborsato';
      case WalletRefundStatus.REJECTED:
        return 'Rifiutato';
      default:
        return status;
    }
  }

  getStatusSeverity(status?: WalletRefundStatus): 'success' | 'info' | 'warning' | 'danger' {
    if (!status) return 'info';
    switch (status) {
      case WalletRefundStatus.REQUESTED:
        return 'warning';
      case WalletRefundStatus.REFUNDED:
        return 'success';
      case WalletRefundStatus.REJECTED:
        return 'danger';
      default:
        return 'info';
    }
  }

  getEntityName(entity?: Entity | any): string {
    if (!entity) return '';
    
    if (entity.business_name) {
      return entity.business_name;
    }
    
    return `${entity.name || ''} ${entity.surname || ''}`.trim();
  }
}
